<template>
  <section :class="{ 'section-builder-logo-band': true }">
    <GeneralTheme :theme="configuration">
      <div
        :class="{
          'container mx-auto': !fullWidthContent,
          'fluid-container px-5 lg:px-10': fullWidthContent,
        }"
      >
        <LogoBand
          v-if="logoBandData"
          :data="logoBandData"
        />
      </div>
    </GeneralTheme>
  </section>
</template>

<script setup lang="ts">
import LogoBand from './LogoBand.vue';
import GeneralTheme from '~/components/Molecules/Themes/GeneralTheme.vue';
import type { SectionBuilderLogoBand } from '~/sanity/types';
import { useRefsStore } from '~/composables/refsStore';

const props = defineProps<SectionBuilderLogoBand>();

const { getResolvedLogoBand } = useRefsStore();
const logoBandData = await getResolvedLogoBand(props.logoBand?.reference?._ref);
</script>

<style lang="scss" scoped>
.section-builder-logo-band {
  @media (min-width: 1024px) and (max-width: 1699px) {
    .fluid-container {
      max-width: 100%;
    }
  }
  @media (min-width: 1700px) {
    .fluid-container {
      max-width: 1600px;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
}
</style>
